export enum ECameraFunction
{
  UNKNOW = 0,
  VIEWER = 1,
  TRACKING = 2,
  AUXILIAR = 3,
  WEBCAM = 4
}
